<template>
  <div class="home_box">
    <!-- <Header @name="updateTitle($event)" class="herder"></Header> -->
    <!-- <div class="pt-8"></div> -->
    <div class="content">
      <div class="banner">
        <img :src="banner" class="banner_img" id="home">
      </div>
      <div class="serve">
        <b-container>
          <div class="box1">
            <h1 id="server">服务范围</h1>
            <p>—SERVICE—</p>
            <span>多元化服务体系 多端覆盖 多行业服务经验 您正好有需求 我们刚好够专业</span>
          </div>
          <b-row>
            <b-col>
              <div class="serve_box2">
                <img src="../assets/3.png">
                <h4>网站建设</h4>
                <p>解决企业建站需求，网站安全
                  终身维护</p>
              </div>

            </b-col>
            <b-col>
              <div class="serve_box2">
                <img src="../assets/2.png">
                <h4>APP定制</h4>
                <p>对苹果iOS、安卓Android等平台的
                  应用程序提供专业优质的用户体验及
                  技术开发</p>
              </div>

            </b-col>
            <b-col>
              <div class="serve_box2">
                <img src="../assets/4.png">
                <h4>微信开发</h4>
                <p>满足用户对微信公众号及小程序的
                  需求，帮助用户快速实现全新的服
                  务平台

                </p>
              </div>

            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="case">
        <b-container>
          <div class="box1">
            <h1 id="case">案例展示</h1>
            <p>—CASE—</p>
            <span>最专业的品牌服务 为您创作更高的价值
            </span>
          </div>
          <div class="case_box2 row">
            <div class="case_box3 col-4" v-for="(item,index) in data" :key="index">
              <div class="pox" @mouseover="selectStyle (item) " @mouseout="outStyle(item)">
                <img :src="item.navigation" class="case_img">

                <div class="active" v-show="item.active">
                  <b-row>
                    <b-col v-show="item.ios_url"><img :src="item.ios_url" class="img" >
                      <p>- IOS下载 -</p>
                    </b-col>
                    <b-col v-show="item.android_url"><img :src="item.android_url" class="img">
                      <p>- 安卓下载 -</p>
                    </b-col>
                  </b-row>
                  <b-button variant="outline-light" size="sm" pill class="btn" @click="look(item)">查看详情</b-button>
                </div>
              </div>
              <p>
                {{item.name}}</p>
              <span>{{item.intro}}</span>
            </div>

          </div>

          <p class="look" @click="LookMore">查看更多>></p>
        </b-container>
      </div>
      <div class="team">
        <b-container>
          <div class="box1">
            <h1 id="team">我们的团队</h1>
            <p>—OUR TEAM—</p>
            <span>最专业的品牌服务 为您创作更高的价值
            </span>
          </div>
          <div class="team_box2 row">
            <div class="team_box3 col-lg-3 col-md-3 col-xs-6 col-sm-12" v-for="(item,index) in team" :key="index">
              <img :src="item.avatar">
              <h6>{{item.username}}</h6>
              <p>{{item.position}}</p>
            </div>

          </div>
        </b-container>

      </div>
      <div class="advantage">
        <b-container>
          <h4>我们的优势</h4>
          <p>{{advantage}}</p>
          <b-row>
            <b-col><img src="../assets/icon_team1.png" class="img">资深工程师团队</b-col>
            <b-col><img src="../assets/icon_team2.png" class="img">完善的服务体系</b-col>
            <b-col><img src="../assets/icon_team3.png" class="img">良好的售后支持</b-col>
          </b-row>
        </b-container>
      </div>
      <div class="flow">
        <b-container>
          <h6>服务流程</h6>
          <img src="../assets/server.png" class="img">
        </b-container>
      </div>
    </div>

    <!-- <Footer id="call"></Footer> -->
  </div>
</template>
<script>
  import axios from 'axios'
  import Header from "@/components/header.vue";
  import Footer from "@/components/footer.vue";
  import local from '../utils/local'

  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {
        banner: '',
        advantage: '',
        team: '',
        data: []
      };
    },
    methods: {
      // updateTitle($event) {
      //   console.log($event);
      //   const returnEle = document.querySelector(`#${$event}`);
      //   console.log(returnEle);

      //   if (!!returnEle) {
      //     returnEle.scrollIntoView(true);
      //   }
      // },
      LookMore() {
        this.$router.push('/case')
      },
      selectStyle(item) {
        // item.active=true;
        var _this = this;
        this.$nextTick(function () {
          this.data.forEach(function (item) {
            _this.$set(item, 'active', false);
          });
          this.$set(item, 'active', true);
        });
      },
      outStyle(item) {
        this.$set(item, 'active', false);
      },
      getInfo() {
        axios.post('http://api1.home.didigo.es/admin/admin/index').then(res => {
          this.banner = res.data.data.msg[0].banner
          this.advantage = res.data.data.par[0].advantage
          this.team = res.data.data.team
          this.data = res.data.data.instance;
          // local.save("data", res.data.data);

        })
        
      },
      look(data) {
        this.$router.push({
          path: `/details`,
          query: {
            data: JSON.stringify(data),
          }
        });
      }
    },
    created() {
      this.getInfo();
      // document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;
    },
    mounted(){
      this.getInfo();

    }
  };
</script>

<style lang="less" scoped="scoped">
  .home_box {
    width: 100%;
    position: relative;
  }

  .main {
    position: absolute;
  }

  .header {
    // position: absolute;
  }

  .pt-8 {
    margin-top: 80px;
  }

  .content {
    padding-top: 80px;

    // margin-top: 80px;
    // position: absolute;
  }

  .banner {
    width: 100%;
    margin: 0 auto;

    .banner_img {
      width: 100%;
      height: 450px;

    }
  }

  .box1 {
    text-align: center;

    h1 {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    p {
      font-size: 14px;
      color: #666;
      margin-bottom: 10px;
    }

    span {
      color: #808080;
    }
  }

  .serve {
    margin-top: 50px;

    .row {
      margin-top: 80px;

      .serve_box2 {
        text-align: center;

        h4 {
          margin-top: 10px;
          font-weight: bold;
          font-size: 24px;
          color: #333;
        }

        p {
          margin-top: 20px;
          line-height: 24px;
          font-size: 14px;
          color: #666;
        }
      }

    }


  }

  .case {
    margin-top: 50px;
    background: #f9f9fb;

    .row {
      margin: 0;
    }

    .case_box2 {
      margin-bottom: 50px;
      width: 100%;

      .col-4 {
        padding: 0;
      }

      .case_box3 {
        // width: 300px;
        margin-top: 80px;
        text-align: center;

        p {
          font-size: 16px;
          color: #333;
          line-height: 45px;
          margin: 0;
        }

        .pox {
          position: relative;
          width: 320px;
          height: 240px;

          .case_img {
            width: 320px;
            height: 240px;
          }

          .active {
            width: 100%;
            height: 240px;
            position: absolute;
            padding: 30px 10px;
            background: rgba(0, 0, 0, 0.5) !important;
            top: 0;
            left: 0;
            margin: 0;

            .col {
              text-align: center;

              p {
                color: #fff;
                z-index: 100;
              }

              .img {
                width: 110px;
                height: 110px;
              }


            }

            .btn {
              width: 120px;
              
            }
          }
        }

        span {
          font-size: 12px;
          color: #999;

        }
      }

    }

    .look {
      width: 100%;
      text-align: center;
      color: #28a6fc;
      font-size: 14px;
    }


  }

  .team {
    margin-top: 80px;

    .team_box2 {
      width: 100%;
      // display: flex;
      // flex-wrap: wrap;
      margin-top: 80px;

      .team_box3 {
        width: 25%;
        text-align: center;
        border: 1px solid #f2f2f2;
        border-left: none;
        border-top: none;

        img {
          width: 150px;
          height: 150px;
        }

        h6 {
          font-size: 24px;
          color: #333;
          margin: 10px 0;
        }

        p {
          font-size: 14px;
          color: #666;
          margin-bottom: 28px;
        }
      }
    }

  }

  .advantage {
    padding: 0 50px;
    height: 320px;
    width: 100%;
    margin: 50px auto;
    background-image: url('../assets/bg_team.png');
    color: #fff;
    text-align: center;

    h4 {
      padding: 55px 0 15px 0;
      font-size: 24px;
    }

    p {
      font-size: 16px;
    }

    .row {
      margin-top: 80px;
      font-size: 16px;

      img {
        margin-right: 8px;
      }
    }
  }

  .flow {
    h6 {
      font-size: 24px;
      color: #668db1;
      text-align: center;
      margin: 80px 0;

    }

    .img {
      width: 100%;
    }
  }
</style>